import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import {
  TemplateEditorChecklistTemplateVersion,
  ITemplateEditorChecklistTemplateVersion,
} from '@core/entities/checklist/TemplateEditorChecklistTemplateVersion'
import { checklistTemplateKeys } from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetChecklistTemplateVersion = (
  payload: RequestTypes['getChecklistTemplateVersion'],
  options?: UseQueryOptions<
    ITemplateEditorChecklistTemplateVersion,
    RequestErrorType,
    TemplateEditorChecklistTemplateVersion
  >,
) => {
  return useQuery({
    select: TemplateEditorChecklistTemplateVersion.new,
    ...checklistTemplateKeys.getVersion(payload),
    ...options,
  })
}
